import { Button, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { X } from 'ts-react-feather-icons';

const useStyles = makeStyles(() => ({
  dialog: {
    textAlign: 'center',
  },
  dialogTitle: {
    paddingTop: '35px',
  },
  dialogTitleText: {
    display: 'inline-block',
    marginRight: '5px',
  },
  dialogContent: {
    paddingLeft: '15%',
    paddingRight: '15%',
  },
  dialogActions: {
    marginTop: '50px',
    marginBottom: '25px',
  },
  cancelButton: {
    color: 'white',
    backgroundColor: '#8DA8B2',
    justifySelf: 'flex-end',
    marginLeft: '20px',
  },
  exitDialogIcon: { display: 'inline-block', right: '15px', top: '15px', position: 'absolute' },
  termsAndConditionsLinks: {
    color: '#44D2F2',
  },
}));

type Props = {
  open: boolean;
  onAccept: () => void;
  onCancel: () => void;
};

const Acknowledgement = ({ open, onAccept, onCancel }: Props) => {
  const classes = useStyles();

  return (
    <Dialog open={open} className={classes.dialog}>
      <DialogTitle className={classes.dialogTitle}>
        <Typography className={classes.dialogTitleText} variant="h4">
          Terms and Conditions
        </Typography>
        <IconButton className={classes.exitDialogIcon} onClick={() => onCancel()} size="large">
          <X />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Typography>
          Before creating an account, you must agree to the Trustate{' '}
          <a
            href="https://www.trustate.com/privacy-policy"
            target="_blank"
            rel="noreferrer"
            className={classes.termsAndConditionsLinks}
          >
            Privacy Policy
          </a>
          <span>, </span>
          <a
            href="https://www.trustate.com/terms-of-service"
            target="_blank"
            rel="noreferrer"
            className={classes.termsAndConditionsLinks}
          >
            Terms of Service
          </a>
          <span>, and </span>
          <a
            href="https://www.trustate.com/termsofuse"
            target="_blank"
            rel="noreferrer"
            className={classes.termsAndConditionsLinks}
          >
            Terms of Use
          </a>
          <span>.</span>
        </Typography>
        <div className={classes.dialogActions}>
          <Button variant="contained" color="secondary" onClick={() => onAccept()}>
            I Agree
          </Button>
          <Button className={classes.cancelButton} variant="contained" onClick={() => onCancel()}>
            Cancel
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default Acknowledgement;
